var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.2656 9.72512c-.5599-.64777-1.205-1.21987-1.9179-1.69891.2151-.01736.4327-.02621.6523-.02621 4.4183 0 8 3.5817 8 8s-3.5817 8-8 8-8-3.5817-8-8c0-1.7931.5899-3.4484 1.5862-4.7824.1364-.0117.2744-.0176.4138-.0176.5267 0 1.0336.0848 1.5077.2416-1.1777 1.1606-1.9077 2.7743-1.9077 4.5584 0 3.5346 2.8654 6.4 6.4 6.4s6.4-2.8654 6.4-6.4c0-3.1013-2.2059-5.6875-5.1344-6.27488z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7344 22.2749c.5599.6477 1.205 1.2199 1.9179 1.6989-.2151.0174-.4327.0262-.6523.0262-4.41828 0-8-3.5817-8-8s3.58172-8 8-8c4.4183 0 8 3.5817 8 8 0 1.7931-.5899 3.4484-1.5862 4.7824-.1364.0117-.2744.0176-.4138.0176-.5267 0-1.0336-.0848-1.5077-.2416 1.1777-1.1606 1.9077-2.7743 1.9077-4.5584 0-3.5346-2.8654-6.4-6.4-6.4-3.53462 0-6.4 2.8654-6.4 6.4 0 3.1013 2.20594 5.6875 5.1344 6.2749z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/Circles.8450586ab71570c421e5638f843ad8d7.svg";
export { ForwardRef as ReactComponent };